/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:a98d7e57-3f9a-4ad5-9edb-f7ad1e322341",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_aQS9bRRGS",
    "aws_user_pools_web_client_id": "67mo60kc1nuku63j021m31rmcg",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
    // "aws_dynamodb_all_tables_region": "eu-west-2",
    // "aws_dynamodb_table_schemas": [
    //     {
    //         "tableName": "workouts-dev",
    //         "region": "eu-west-2"
    //     }
    // ],
    // "aws_cloud_logic_custom": [
    //     {
    //         "name": "workout2",
    //         "endpoint": "https://wobxakvml3.execute-api.eu-west-2.amazonaws.com/prod",
    //         "region": "eu-west-2"
    //     }
    // ]
};


export default awsmobile;
